import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { usePartnerAccount } from '../../providers/PartnerAccount.provider';
import { useConfirmationDialogue } from '../../providers/ConfirmationDialogue.provider';
import { PartnerAccountRequest, PartnerAccountResponse } from '../useApi/usePostPartnerAccount';
import { usePendingData } from '../../providers/PendingData.provider';

const useAccountCreationFailureDialogue = (): {
  showDialogue: () => void;
  response: PartnerAccountResponse | undefined;
  postPartnerAccount: (requestParams: PartnerAccountRequest) => void;
} => {
  const history = useHistory();

  const { response, postPartnerAccount } = usePartnerAccount();
  const { reset } = usePendingData();
  const { provideProps, showDialogue } = useConfirmationDialogue();

  useEffect(() => {
    const handlers = {
      error: () => {
        provideProps({
          title: 'Error! Your account has not been created.',
          subTitle: response?.errorMessage || '',
          status: 'error',
          confirm: {
            label: 'Back to Accounts',
            action: () => {
              reset();
              history.push('/accounts');
            },
          },
          cancel: {
            label: 'Stay Here',
            action: () => {},
          },
        });
      },
    };

    if (response?.errorMessage) handlers.error();
  }, [response]);

  return { showDialogue, response, postPartnerAccount };
};

export default useAccountCreationFailureDialogue;
